import React from "react";

import {
  Box,
  FormControl,
  FormLabel,
  Stack,
  StackDivider,
} from "@chakra-ui/react";
import CheckboxCardGroup from "../../../utils/chakra/CheckboxCardGroup";
import RadioCardGroup from "../../../utils/chakra/RadioCardGroup";
import FormDescription from "../../../utils/chakra/FormDescription";

import {
  AnswerFragment,
  QuestionFragment,
  QuestionTypeEnum,
  ReportFragment,
} from "../../../../graphql/generated/definitions";
import { QuestionWithAnswers } from "../../types/ReportFormTypes";

import usePreviousAnswers from "../../hooks/usePreviousAnswers";

import QuestionActions from "./QuestionActions";
import AnswerReviewDispatch from "../answers/AnswerReviewDispatch";

const is = (q: QuestionFragment, t: QuestionTypeEnum) => q.type === t;

type QuestionReviewDispatchProps = {
  question: QuestionFragment;
  report: ReportFragment;
  path: `sections.${number}.answers.${number}`;
  sectionIndex: number;
  questionIndex: number;
};

const QuestionReviewDispatch: React.FC<QuestionReviewDispatchProps> = ({
  report,
  question,
  path,
  sectionIndex,
  questionIndex,
}) => {
  const answers = usePreviousAnswers(question as QuestionWithAnswers, report);

  return (
    <Box>
      <FormControl isRequired={question.required} id={`${path}.value`}>
        <FormLabel fontWeight="semibold" fontSize="xl">
          {sectionIndex + 1}.{questionIndex + 1}
          {" • "}
          {question.label}
        </FormLabel>
        {question.description && (
          <FormDescription>{question.description}</FormDescription>
        )}
        <QuestionActions question={question} report={report} />
        <Stack spacing="7" divider={<StackDivider maxW="2xl" />}>
          {is(question, "QuestionSelectorMultiple") && (
            <CheckboxCardGroup
              isInvalid={false}
              isDisabled
              options={question.options}
            />
          )}
          {!is(question, "QuestionSelectorMultiple") &&
            !is(question, "QuestionText") && (
              <RadioCardGroup isDisabled options={question.options} />
            )}
          {answers.map((answer) => (
            <AnswerReviewDispatch
              key={answer.user.id}
              {...{ answer: answer as AnswerFragment, question, path }}
            />
          ))}
        </Stack>
      </FormControl>
    </Box>
  );
};

export default React.memo(QuestionReviewDispatch);
